import {
    Table,
    TableRow,
    TableCell,
    Paragraph,
    TextRun,
    WidthType,
} from "docx";

import { TLevel } from "../../../services/budget/read-budgets";

/**
 * Generates a scope table for DOCX documents
 */

type TGenerateScopeTable = {
    levelConfig: TLevel[];
    tableData: string[][];
};

export const generateScopeTable = ({
    levelConfig,
    tableData,
}: TGenerateScopeTable): Table => {
    // Dados da tabela (temporários para exemplo)

    const scopeTable = new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
            // Cabeçalho
            new TableRow({
                children: levelConfig.map(
                    (levelData) =>
                        new TableCell({
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: levelData.name,
                                            bold: true,
                                        }),
                                    ],
                                }),
                            ],
                            width: { size: 40, type: WidthType.PERCENTAGE },
                        })
                ),
            }),
            // Dados da tabela
            ...tableData.map(
                (row) =>
                    new TableRow({
                        children: [
                            new TableCell({
                                children: [new Paragraph(row[0])],
                            }),
                            new TableCell({
                                children: [new Paragraph(row[1])],
                            }),
                            new TableCell({
                                children: [new Paragraph(row[2])],
                            }),
                        ],
                    })
            ),
        ],
    });

    return scopeTable;
};
